import { objectsRHandler } from '@/utils/objectsRHandler';
import { getApiData, API_TYPES } from '@/utils/modelsApi';
import { ROLES } from '@/constants/roles';
import Address from '../list/address';
import AddressSpace from '../list/address-space';

const PRIVATE_ROLES = [ROLES.organization];

const API_DATA = {
  [API_TYPES.private]: {
    path: 'addresses',
    get objects() {
      const { path } = this;
      return {
        ...objectsRHandler(path, Address),
      };
    },
  },
  [API_TYPES.public]: {
    path: 'public/addresses',
    get objects() {
      const { path } = this;
      return {
        ...objectsRHandler(path, Address),
      };
    },
  },
};

const API_DATA_SPACES = {
  [API_TYPES.private]: {
    path: 'address-spaces',
    get objects() {
      const { path } = this;
      return {
        ...objectsRHandler(path, AddressSpace),
      };
    },
  },
  [API_TYPES.public]: {
    path: 'public/address-spaces',
    get objects() {
      const { path } = this;
      return {
        ...objectsRHandler(path, AddressSpace),
      };
    },
  },
};

export const AddressesManager = {
  get objects() {
    return { ...getApiData(API_DATA, PRIVATE_ROLES).objects };
  },
  get spaces() {
    return { ...getApiData(API_DATA_SPACES, PRIVATE_ROLES).objects };
  },
};
